var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.555667C10.9882 0.555667 10.5 0.555664 12.6 0.555664H16.185C17.1874 0.555664 18 1.35823 18 2.34826V11.2075C18 12.1975 17.1874 13.0001 16.185 13.0001H1.815C0.812603 13.0001 0 12.1975 0 11.2075V2.34826C0 1.35823 0.812603 0.555664 1.815 0.555664H5.4C8 0.555664 7.01178 0.555667 9 0.555667ZM15.9773 2.91427L12.516 5.46017C10.4306 6.99399 7.57058 6.98438 5.49587 5.43659L2.11729 2.91609C1.91898 2.76814 1.63678 2.80699 1.48698 3.00285C1.33719 3.19871 1.37652 3.47743 1.57483 3.62537L4.95341 6.14588C7.34731 7.93179 10.6474 7.94287 13.0535 6.17308L16.5148 3.62719C16.7142 3.48058 16.7554 3.20213 16.607 3.00527C16.4585 2.8084 16.1766 2.76766 15.9773 2.91427Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.d1869b9b5fd67676b7057f65e18038ad.svg";
export { ForwardRef as ReactComponent };